import { connect } from 'react-redux'
import ConfirmPopupComponent from "../components/ConfirmPopupComponent";
import { loadCommonPopup} from '../actions/index';
const mapStateToProps = (state, ownProps) => ({
    
})
         
const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatchAction : (action) => {
        dispatch(action)
    },
    confirmPopup : (data) => {
        dispatch({type : "CONFIRM_POPUP", data : data})
    }
})
  
const ConfirmPopup = connect(mapStateToProps,mapDispatchToProps)(ConfirmPopupComponent)

export default ConfirmPopup


// WEBPACK FOOTER //
// ./src/containers/ConfirmPopup.js